/** One student's appearance in a month's change log. Maps StudentChangeEntryResource (PascalCase). */
export interface StudentChangeEntry {
  studentId: number
  firstName: string
  lastName: string
  indificationNo: string
  passport?: string
  // Only on "changed" entries — what that month's version set the student to.
  shiftId?: number
  scholarship?: number
  isActive?: boolean
}

/**
 * What changed in one Hebrew month: who joined, who left, whose shift/scholarship changed, and how
 * many students were active by the end of it. This is what explains a payment count moving between
 * two months — a student missing from a new report is stamped as having left in that report's month.
 */
export default class StudentMonthlyChange {
  month: number

  numericYear: number

  monthName: string

  yearText: string

  joined: StudentChangeEntry[]

  left: StudentChangeEntry[]

  changed: StudentChangeEntry[]

  activeCount: number

  constructor(m: any) {
    this.month = m.Month
    this.numericYear = m.NumericYear
    this.monthName = m.MonthName ?? ''
    this.yearText = m.YearText ?? ''
    this.joined = (m.Joined ?? []).map(mapEntry)
    this.left = (m.Left ?? []).map(mapEntry)
    this.changed = (m.Changed ?? []).map(mapEntry)
    this.activeCount = m.ActiveCount ?? 0
  }

  get hasChanges(): boolean {
    return (
      this.joined.length > 0 || this.left.length > 0 || this.changed.length > 0
    )
  }
}

const mapEntry = (e: any): StudentChangeEntry => ({
  studentId: e.StudentId,
  firstName: e.FirstName ?? '',
  lastName: e.LastName ?? '',
  indificationNo: e.IndificationNo ?? '',
  passport: e.Passport ?? undefined,
  shiftId: e.ShiftId ?? undefined,
  scholarship: e.Scholarship ?? undefined,
  isActive: e.IsActive ?? undefined
})
